/** 
 * Add any aditional functionality we need in the vendor dashboard 
 */
class CTTDokan {

  constructor() {}

  export (data) {
    jQuery("<div class='CTT-sending'>" + CTT_label_sending + "</div>").insertBefore('.CTT-export-btn');
    jQuery.ajax({
      url: dokan.ajaxurl,
      method: 'GET',
      data: data,
      success: function (resp) {
        jQuery(".CTT-sending").remove();
        jQuery(resp)
          .insertAfter('.CTT-export-btn');
      },
      error: function (err) {
        jQuery(".CTT-sending").remove();
        jQuery("An error has occurred " + JSON.stringify(err))
          .insertAfter(".CTT-export-btn");
      }
    });
  }

  exportSelected() {
    let selectedIds = [];
    jQuery("input[name='bulk_orders[]']:checked")
      .each(function (idx, elem) {
        selectedIds[idx] = jQuery(elem)
          .val();
      });

    if (selectedIds.length == 0) {
      alert("No orders are selected");
      return;
    }
    let data = {
      'action': 'CTT_dokan_export_selected',
      'ids': selectedIds
    };

    this.export(data);
  }

  exportAll() {
    let data = {
      'action': 'CTT_dokan_export_all'
    };

    this.export(data);
  }
}


jQuery(function () {
  window.CTT_dokan = new CTTDokan();
});
